var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areas-container",attrs:{"id":"orgArea"}},[_c('area-node',{attrs:{"node":_vm.areaTree,"level":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }